<div class="threedot-icon" cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="toggle()"></div>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isVisible()"
    [cdkConnectedOverlayPositions]="overlayPositions()" (overlayOutsideClick)="isVisible.set(false)">
    <div class="dialog-wrapper" [class]="theme()">
         <ng-content></ng-content>
    </div>
</ng-template>
